// Icon search: every word typed must appear in the icon's name or category. Spaces,
// hyphens and underscores all separate words, so "arrow left" finds "arrow-left".

export const SEARCH_LIMIT = 150;

const words = (text) => text.toLowerCase().split(/[\s\-_]+/).filter(Boolean);

// Lower is better: exact name, name starts with the query, a word starts with each
// term, any substring, then matches only through the category name
function rank(icon, terms) {
  const name = icon.name.toLowerCase();
  const joined = terms.join("-");
  if (name === joined) return 0;
  if (name.startsWith(joined)) return 1;
  const nameWords = words(name);
  if (terms.every((term) => nameWords.some((word) => word.startsWith(term)))) return 2;
  if (terms.every((term) => name.includes(term))) return 3;
  return 4;
}

export function searchIcons(icons, query) {
  const terms = words(query);
  if (!terms.length) return [];
  return icons
    .filter((icon) => {
      const haystack = `${icon.name} ${icon.cat}`.toLowerCase();
      return terms.every((term) => haystack.includes(term));
    })
    .map((icon, index) => ({ icon, index, rank: rank(icon, terms) }))
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .map((match) => match.icon);
}
